import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import styles from './Relationship.module.css';

const LOCK_TEXT = 'Disponível no plano Profissional. Clique para ver os planos.';

/**
 * Bloco do painel Relacionamento. Com itens, mostra cabeçalho e lista;
 * sem itens, vira uma pílula discreta na linha "Em dia". Se o plano não
 * inclui o recurso, aparece com cadeado e o clique abre a troca de plano.
 */
function RelationshipSection({ icon, tone, title, hint, count, lock, children }) {
  const locked = Boolean(lock?.locked);

  if (count === 0) {
    const chip = (
      <button
        type="button"
        className={`${styles.chip} ${locked ? styles.chipLocked : ''}`}
        onClick={locked ? lock.openUpgrade : undefined}
        tabIndex={locked ? 0 : -1}
      >
        <span className={`${styles.chipIcon} ${styles[tone]}`}>{icon}</span>
        {title}
        {locked && <LockOutlinedIcon style={{ fontSize: 13 }} />}
      </button>
    );
    return (
      <>
        {locked ? <Tooltip title={LOCK_TEXT} arrow>{chip}</Tooltip> : chip}
        {lock?.modal}
      </>
    );
  }

  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <span className={`${styles.sectionIcon} ${styles[tone]}`}>{icon}</span>
        <div className={styles.sectionTitles}>
          <span className={styles.sectionTitle}>{title}</span>
          {hint && <span className={styles.sectionHint}>{hint}</span>}
        </div>
        {locked && (
          <Tooltip title={LOCK_TEXT} arrow>
            <button type="button" className={styles.lockButton} onClick={lock.openUpgrade} aria-label={LOCK_TEXT}>
              <LockOutlinedIcon style={{ fontSize: 15 }} />
            </button>
          </Tooltip>
        )}
        <span className={styles.sectionCount}>{count}</span>
      </div>
      <div className={styles.sectionList}>{children}</div>
      {lock?.modal}
    </div>
  );
}

export default RelationshipSection;
